import React from 'react'
import './Testimonial.css'
import {Swiper, SwiperSlide} from 'swiper/react'
import profilePic1 from "../../img/profile1.jpg"
import profilePic2 from "../../img/profile2.jpg"
import profilePic3 from "../../img/profile3.jpg"
import profilePic4 from "../../img/profile4.jpg"
import AmazonML from '../../img/AmazonML.png'
import Flipkart from '../../img/flipkart.png'
import CodingNinjas from '../../img/codingNinjas.png'
import Leetcode from '../../img/leetcode.png'
import { Pagination } from "swiper" 
import 'swiper/css/pagination'
import 'swiper/css'
const Testimonial = () => {
    const clients = [
        {
            img : AmazonML,
            review :
                "Selected in Amazon Summer School 2022. The application process was challenging, but I persevered, and I feel proud to have earned a spot in such a competitive program.",
        },
        {
            img : Flipkart,
            review :
                "Participating in Flipkart Grid 4.0 has been an incredible experience for me. Throughout the program, I had the opportunity to attend workshops, webinars, and networking sessions with some of the brightest minds in the industry.",
        },
        {
            img : CodingNinjas,
            review :
                "Participating in the Coding Ninjas coding competition was an amazing experience for me. The competition was challenging, but it was a great opportunity to showcase my skills and compete with other talented coders. It was a great validation of the hard work that I had put in.",
        },
        {
            img : Leetcode,
            review :
                "Solving more than 400+ problems on LeetCode has been an incredible experience for me. It was a journey that started with a desire to improve my coding skills and ended up as a profound learning experience.",
        },
    ];
  return (
    <div className="t-wrapper">
        <div className="t-heading">
            <span>Some          </span>
            <span>Exceptional   work  </span>
            <span> from me .....</span>
            <div className="blur t-blur1" style={{background: "var(--purple)"}}></div>
            <div className="blur t-blur2" style={{background: "skyblue"}}></div>
        </div>
        {/* Slider*/}
        <Swiper
            modules={[Pagination]}
            slidesPerView={1}
            pagination={{clickable: true}}
        >
            {clients.map((client,index)=>{
               return (
                    <SwiperSlide key={index}>
                        <div className="testimonial">
                            <img src ={client.img} alt=""/>
                            <span>{client.review}</span>
                        </div>
                    </SwiperSlide>
               )
            })}
        </Swiper>
    </div>
  );
};

export default Testimonial